// HTML Entity Decoder Utility
// Decodes HTML entities like &quot;, &amp;, &lt;, &gt;, &#39; etc.

/**
 * Decodes HTML entities in a string to their proper characters
 * @param {string} str - The string containing HTML entities to decode
 * @returns {string} - The decoded string
 */
export const decodeHtmlEntities = (str) => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  // Create a temporary textarea element to leverage browser's built-in decoding
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
};

/**
 * Decodes HTML entities in an array of strings
 * @param {Array} arr - Array of strings that may contain HTML entities
 * @returns {Array} - Array with decoded strings
 */
export const decodeHtmlEntitiesArray = (arr) => {
  if (!Array.isArray(arr)) {
    return arr;
  }

  return arr.map(item => {
    if (typeof item === 'string') {
      return decodeHtmlEntities(item);
    }
    return item;
  });
};

/**
 * Decodes HTML entities in object properties that are strings
 * @param {Object} obj - Object that may contain string properties with HTML entities
 * @param {Array} properties - Array of property names to decode (optional - decodes all string properties if not provided)
 * @returns {Object} - Object with decoded string properties
 */
export const decodeHtmlEntitiesObject = (obj, properties = null) => {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  const decoded = { ...obj };
  const propsToCheck = properties || Object.keys(obj);

  propsToCheck.forEach(prop => {
    if (decoded[prop] && typeof decoded[prop] === 'string') {
      decoded[prop] = decodeHtmlEntities(decoded[prop]);
    }
  });

  return decoded;
};